import React from 'react';

import cn from 'utils/cn';

import { ICardContainerProps } from 'client/common/components/card-container/CardContainer.types';

import './CardContainer.css';

const b = cn('card-information');

const CardContainer = ({ children }: ICardContainerProps) => {

    return (
        <div className={b('desktop-card-container')}>
            {children}
        </div>
    );
};

export default CardContainer;
